<template>
    <v-card variant="outlined">
        <nuxt-link
            no-prefetch
            :to="{name: 'extraService', query: {name: product.info.name}}"
            class="text-subtitle-2 text-decoration-none"
        >
            <v-img
                tile
                class="text-white align-end"
                height="200"
                :src="$filters.imageUrl(product.info.imageUrl, 200)"
                :alt="product.info.name"
                :lazy-src="$filters.srcHost('/placeholder.png')"
                @error="imgError = true"
            >
                <template v-slot:placeholder>
                    <v-row
                        v-show="!imgError && product.info.imageUrl"
                        class="fill-height ma-0"
                        align="center"
                        justify="center"
                    >
                        <v-progress-circular indeterminate color="grey-lighten-5" />
                    </v-row>
                </template>
                <v-card-title>
                    {{ product.info.name }}
                </v-card-title>
            </v-img>
        </nuxt-link>
        <v-card-text v-if="product.price && !minPriceOffer.soldOut">
            <nuxt-link
                :to="{name: 'extraService', query: {name: product.info.name}}"
                no-prefetch
                class="text-h6 text-decoration-none"
            >
                <strong data-cy="client-price" class="text-black">
                    {{ $t('from') }} {{ $filters.price(minPriceOffer.price) }}
                </strong>
            </nuxt-link>
            <discount-label :price="minPriceOffer.price" />
            <commission-amount :commission="minPriceOffer.price.commission" />
        </v-card-text>
        <v-expand-transition>
            <div v-if="expanded">
                <extra-service-offer-card
                    v-for="(offer, offerIndex) in sortedOffers"
                    :key="offerIndex"
                    :offer="offer"
                    :full-card="false"
                    :data-cy="`extra-service-offer-card-${offerIndex}`"
                >
                    <template v-slot:price>
                        <slot name="price" :offer="offer" />
                    </template>
                </extra-service-offer-card>
                <v-list-item
                    v-if="expanded === expandedLimit && product.offers.length > expandedLimit"
                    density="compact"
                    class="d-flex justify-center"
                    @click.stop="expanded = product.offers.length"
                >
                    <v-icon>mdi-chevron-down</v-icon>
                </v-list-item>
            </div>
        </v-expand-transition>
        <v-card-actions>
            <v-btn variant="text" block @click.stop="open">
                <v-icon :icon="`mdi-chevron-${!expanded || expanded < product.offers.length ? 'down' : 'up'}`" />
            </v-btn>
        </v-card-actions>
    </v-card>
</template>

<script lang="ts">
    import {Component} from 'vue-facing-decorator'
    import DiscountLabel from '~src/components/snippets/discountLabel.src'
    import CommissionAmount from '~src/components/snippets/CommissionAmount.vue'
    import {ExtraServiceCard} from '~src/components/extraServices/search/offers/ExtraServiceCard.vue'
    import ExtraServiceOfferCard from '~src/components/extraServices/info/ExtraServiceOfferCard.vue'

    @Component({
        components: {
            DiscountLabel,
            CommissionAmount,
            ExtraServiceOfferCard,
        },
    })
    export class ExtraServiceCardMobile extends ExtraServiceCard {
        open() {
            if (!this.expanded || this.expanded >= this.product.offers.length) {
                this.toggleOffers()
            } else {
                this.showAllOffers()
            }
        }

        showAllOffers() {
            this.expanded = this.product.offers.length
        }
    }

    export default ExtraServiceCardMobile
</script>

<style scoped lang="scss">
    .v-card-title {
        background: rgba(0, 0, 0, 0.5);

        a {
            color: #ffffff;
            text-decoration: none;
        }
    }
</style>
